import styled, { css } from 'styled-components';
import movingIcon from '../assets/svg/moving.svg';
import signatureIcon from '../assets/svg/signature.svg';

export const FlexWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: ${p => (p.flex ? p.flex : 'row')};
  padding: ${p => (p.padding ? p.padding : '20px')};
  width: 100%;

  ${p =>
    p.centered &&
    css`
      justify-content: center;
      align-items: center;
    `}

  ${p =>
    p.flexPart &&
    css`
      flex: ${p.flexPart};
    `}

  ${p =>
    p.margin &&
    css`
      margin: ${p.margin};
    `}

  @media (${p => p.theme.mq.mobile}) {
    flex-direction: ${p => (p.mobileColumn ? 'column' : 'row')};
    padding: ${p => (p.padding ? p.padding : '5px')};

    ${p =>
      p.mobileCentered &&
      css`
        justify-content: center;
        align-items: center;
      `}
  }
`;

export const WelcomeSection = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  h1 {
    align-self: flex-start;
  }
`;

export const SwapPreview = styled.section`
  position: relative;
  width: 100%;
  height: calc(100vh-70px);
  padding: ${p => p.theme.base.spacing.huge};

  & div:nth-child(1) {
    background-size: cover;
    left: calc(50% - 200px);
    top: calc(50% - 170px);
    z-index: 3;
  }

  & div:nth-child(2) {
    background-size: cover;
    left: calc(50% - 65px);
    top: calc(50% - 85px);
    z-index: 2;
  }

  & div:nth-child(3) {
    background-size: cover;
    left: calc(50% + 70px);
    top: calc(50% - 0px);
    z-index: 1;
  }

  @media (max-width: 1139px) {
    display: none;
  }
`;

export const ApartmentCard = styled.div`
  background-image: url(${p => p.url});
  border-radius: 5px;
  height: 170px;
  position: absolute;
  width: 270px;

  & span {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 3px;
    bottom: 5px;
    color: white;
    font-size: 12px;
    font-weight: ${p => p.theme.fontBold};
    left: 5px;
    padding: 5px;
    position: absolute;
  }
`;

export const ListBox = styled.div`
  padding: ${p => p.theme.base.spacing.huge} 0;
  width: 100%;

  & ol {
    list-style-type: none;
    padding: 0;

    & li {
      border-radius: 3px;
      margin-bottom: 20px;
      padding: 4px;
      position: relative;

      & p {
        padding-left: 20px;
      }
    }

    & div {
      align-items: center;
      border-radius: 50%;
      border: 1px solid black;
      display: flex;
      height: 15px;
      justify-content: center;
      position: absolute;
      top: 24px;
      width: 15px;

      & span {
        font-size: 10px;
        font-weight: bold;
      }
    }
  }
`;

export const InfoText = styled.span`
  font-size: 12px;
  margin: 10px 0 0 0;
  text-align: center;

  @media (${p => p.theme.mq.desktop}) {
    margin: 0 0 0 20px;
    max-width: 45ch;
    text-align: left;
  }
`;

export const FormWrapper = styled.div`
  border-radius: 3px;
  box-shadow: 0 2px 0px rgba(34, 34, 34, 0.1), 0 2px 0px rgba(34, 34, 34, 0.1);
  margin-top: ${p => p.theme.spacing(8)};
  margin-bottom: ${p => p.theme.spacing(8)};
  padding: ${p => (p.padding ? p.padding : p.theme.spacing(2))};
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.1);

  @media (${p => p.theme.mq.desktop}) {
    padding: ${p => (p.padding ? p.padding : p.theme.spacing(12))};
  }
`;

export const AddLink = styled.p`
  color: ${p => (p.red ? p.theme.color.red : p.theme.color.teal)};
  cursor: pointer;
  font-weight: bold;
`;

export const SupportImgLarge = styled.div`
  background: url(${p => p.url});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 150px;
  padding: 40px;
  width: 150px;

  @media (${p => p.theme.mq.desktop}) {
    height: 300px;
    width: 300px;
  }
`;

export const CenteredHeader = styled.h2`
  text-align: center;
`;

export const ContactMail = styled.a.attrs({
  href: `mailto:${p => p.to}`,
})`
  font-weight: ${p => (p.small ? 'bold' : 'normal')};
  color: ${p => p.theme.color.teal};
  font-size: ${p => (p.small ? '16px' : '24px')};
  text-decoration: none;

  @media (${p => p.theme.mq.mobile}) {
    font-size: ${p => (p.small ? '12px' : '16px')};
  }
`;

export const ContactPhone = styled.a.attrs({
  href: `tel:${p => p.tel}`,
})`
  font-weight: ${p => (p.small ? 'bold' : 'normal')};
  color: ${p => p.theme.color.grayDark};
  font-size: ${p => (p.small ? '16px' : '22px')};
  margin-top: 10px;
  text-decoration: none;
`;

export const MovingIcon = styled.div`
  height: 150px;
  width: 150px;
  background: url(${movingIcon});
`;

export const SignatureIcon = styled.div`
  height: 150px;
  width: 150px;
  background: url(${signatureIcon});
`;

export const ControlP = styled.p`
  font-weight: ${p => (p.bold ? 'bold' : 'normal')}
  max-width: 400px;
`;

export const StartButton = styled.button`
  background-color: ${p => p.theme.color[p.primary ? 'teal' : 'white']};
  box-shadow: ${p => (p.raised ? p.theme.boxShadow2 : 'none')};
  border: 0;
  border-radius: 2px;
  color: ${p => p.theme.color[p.primary ? 'white' : 'black']};
  display: inline-block;
  font-family: ${p => p.theme.base.fontFamily};
  font-size: ${p => (p.big ? '16px' : '12px')};
  font-weight: 500;
  line-height: ${p => (p.big ? '45px' : '30px')};
  padding: ${p => (p.big ? '0 45px' : '0 30px')};
  text-decoration: 0;
  text-transform: uppercase;
  transition: all 0.2s linear;
  white-space: no-wrap;
  width: 100%;

  &:hover,
  &:active {
    background-color: ${p =>
      p.theme.color[p.primary ? p.theme.rgba('teal', 0.6) : 'grayLight']};
    box-shadow: none;
    opacity: 0.8;
  }

  @media (${p => p.theme.mq.mobile}) {
    position: fixed;
    width: 100vw;
    padding: 15px;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const SignLink = styled.a.attrs({
  href: p => p.url,
  target: '_blank',
})`
  border-radius: 2px;
  color: ${p => p.theme.color.whiteTrue};
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  line-height: 45px;
  padding: 0 ${p => p.theme.spacing(12)};
  background-color: ${p => p.theme.color.teal};

  @media (${p => p.theme.mq.mobile}) {
    padding: 0 ${p => p.theme.spacing(4)};
    width: 100&;
  }
`;



// WEBPACK FOOTER //
// ./src/views/styles.js